import { StorageRef, ChartingItemType, CHARTING_TUBE_LABELING_CHECK_ID, ChartingSelectType } from '@caresend/types';
import { capitalize, getUTCTimezoneDate } from '@caresend/utils';
import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__$2 from '../../inputs/DatePicker/DatePicker.vue.js';
import __vue_component__$3 from '../../inputs/FilePicker/FilePicker.vue.js';
import __vue_component__$4 from '../../inputs/SelectComponent.vue.js';
import __vue_component__$5 from '../../inputs/TextBoxPicker/TextBoxPicker.vue.js';
import __vue_component__$6 from '../../inputs/TextInput/TextInput.vue.js';
import __vue_component__$1 from './ChartingChecklistItemCard.vue.js';
import { usePortalStore } from '../portal/store/portal/index.js';
import { setProcedureChartingItems } from '../portal/store/portal/set/procedure.js';
import { formatPatientDataOnTube } from '../TubeLabelingExample/helpers.js';
import __vue_component__$7 from '../TubeLabelingExample/TubeLabelingExample.vue.js';
import '../portal/store/portal/sessionStore.js';
import 'file-saver';
import '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/encryption/model.js';
import 'js-sha256';
import { getStore } from '../../../store/helpers/initStore.js';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../portal/store/storeUtilities/dbSync/dbSyncStore.js';
import '../../../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../database/firebaseConfig/init.js';
import '../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'immutability-helper';
import '../../../router/routes/dev/model.js';
import '../../../router/routes/dev/routes.js';
import '../../../router/routes/dashboard/model.js';
import '../../../router/routes/pro/model.js';
import '../../../router/routes/visitsPage/model.js';
import '../../../router/routes/orderFlow/model.js';
import '../../../router/routes/orderFlow/privateHelpers.js';
import '../../../router/routes/orderFlow/routes.js';
import '../../../router/routes/schedulingFlow/model.js';
import '../../../router/routes/schedulingFlow/routes.js';
import '../../../router/routes/chartingFlow/model.js';
import '../../../router/routes/chartingFlow/routes.js';
import '../../../router/routes/portal/portalRoutes.js';
import '../../../router/routes/portal/model.js';
import '../../../router/routes/visitsPage/routes.js';
import '../dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../store/modules/chartingFlow/model.js';
import '../../../store/modules/office/index.js';
import '../VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../store/modules/office/model.js';
import '../../../store/modules/orderFlow/index.js';
import '../../../store/modules/procedures/model.js';
import '../../../store/modules/schedulingFlow/index.js';
import '../../../store/modules/schedulingFlow/model.js';

var script = defineComponent({
    name: 'ChartingItemCard',
    components: {
        BasicCard: __vue_component__,
        ChartingChecklistItemCard: __vue_component__$1,
        DatePicker: __vue_component__$2,
        FilePicker: __vue_component__$3,
        SelectComponent: __vue_component__$4,
        TextBoxPicker: __vue_component__$5,
        TextInput: __vue_component__$6,
        TubeLabelingExample: __vue_component__$7,
    },
    props: {
        procedureID: {
            type: String,
            required: true,
        },
        /**
         * An array of indices to support charting items nested in groups.
         * Example: [1, 2] - Root ChartingItem of index 1, nested non-group
         * ChartingItem of index 2.
         */
        indexArray: {
            type: Array,
            required: true,
        },
    },
    setup(props) {
        const { procedures } = usePortalStore();
        const storagePath = StorageRef.CHARTING;
        const item = computed(() => procedures.getters.chartingItemByIndexArray(props.procedureID, props.indexArray));
        const isChecklist = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.CHECKLIST; });
        const isDate = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.DATE; });
        const isFiles = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.FILES; });
        const isGroup = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.GROUP; });
        const isNotes = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.NOTES; });
        const isResults = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.RESULTS; });
        const isSelect = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.SELECT; });
        const isText = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.type) === ChartingItemType.TEXT; });
        const isTubeLabeling = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.id) === CHARTING_TUBE_LABELING_CHECK_ID; });
        const textBoxPickerItems = computed(() => { var _a, _b, _c; return (_c = (_b = (_a = item.value) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.map((option) => ({ label: option, value: option }))) !== null && _c !== void 0 ? _c : []; });
        const textBoxPickerHorizontal = computed(() => { var _a; return ((_a = item.value) === null || _a === void 0 ? void 0 : _a.selectType) === ChartingSelectType.TEXT_BOX_PICKER_HORIZONTAL; });
        const setChartingItem = (newItem) => {
            const params = {
                procedureID: props.procedureID,
                newPartialChartingItem: newItem,
                chartingItemIndexArray: props.indexArray,
            };
            setProcedureChartingItems(params);
        };
        const setChartingPhotos = async (encryptedFiles) => {
            if (!encryptedFiles || !item.value)
                return;
            const newItem = {
                files: encryptedFiles,
            };
            setChartingItem(newItem);
        };
        const setText = async (text) => {
            if (!item.value)
                return;
            const newItem = {
                text,
            };
            setChartingItem(newItem);
        };
        const setSelection = async (selection) => {
            if (!item.value)
                return;
            const newItem = {
                selection,
            };
            setChartingItem(newItem);
        };
        /** Currently only supports UTC dates */
        const setDate = async (timestamp) => {
            if (!item.value)
                return;
            const newItem = {
                date: getUTCTimezoneDate(timestamp),
            };
            setChartingItem(newItem);
        };
        const patientDataForTubeLabeling = computed(() => {
            if (!isTubeLabeling.value)
                return;
            const store = getStore();
            const booking = store.getters['procedures/getProcedureBooking'](props.procedureID);
            if (!booking)
                return;
            const patient = store.getters['users/getUserByID'](booking.patientID);
            return formatPatientDataOnTube(patient);
        });
        const resultsPlaceholder = computed(() => { var _a, _b, _c; return (_b = (_a = item.value) === null || _a === void 0 ? void 0 : _a.resultsPlaceholder) !== null && _b !== void 0 ? _b : (_c = item.value) === null || _c === void 0 ? void 0 : _c.title; });
        return {
            capitalize,
            storagePath,
            isChecklist,
            isDate,
            isFiles,
            isGroup,
            isNotes,
            isResults,
            isSelect,
            isText,
            isTubeLabeling,
            item,
            patientDataForTubeLabeling,
            resultsPlaceholder,
            setChartingPhotos,
            setDate,
            setSelection,
            setText,
            textBoxPickerItems,
            textBoxPickerHorizontal,
        };
    },
});

export { script as default };
